var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecords = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.475 11.566a.434.434 0 1 0 0 .868h5.05a.434.434 0 1 0 0-.868zm0 2.018a.434.434 0 1 0 0 .867h5.05a.434.434 0 1 0 0-.867zm-.435 2.451c0-.24.195-.434.435-.434h5.05a.434.434 0 1 1 0 .867h-5.05a.434.434 0 0 1-.435-.433"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.648 5.194q.334-.192.807-.194h6.365L18 8.846v8.703l-.444-.001H18v.027a1.3 1.3 0 0 1-.022.204c-.02.124-.063.295-.151.472a1.33 1.33 0 0 1-.451.518 1.47 1.47 0 0 1-.83.232H7.455q-.474-.001-.806-.194a1.2 1.2 0 0 1-.469-.48 1.6 1.6 0 0 1-.18-.773V6.447c0-.095 0-.44.18-.772.097-.177.246-.353.468-.48Zm.313.905a.76.76 0 0 0-.072.353v11.096c0 .078.004.229.072.353.03.055.07.1.131.136a.7.7 0 0 0 .363.075h9.09a.6.6 0 0 0 .338-.083.44.44 0 0 0 .149-.176.8.8 0 0 0 .078-.294l.001-.015V9.378h-3.897v-3.49h-5.76a.7.7 0 0 0-.361.075.34.34 0 0 0-.132.136",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecords);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/records.91ac5c89.svg";